import { call, put } from 'redux-saga/effects';
import {
  fetchSubscriptionTypesFailure,
  fetchSubscriptionTypesSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { FetchSubscriptionTypesRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { SubscriptionTypeResponse, fetchSubscriptionPlans } from '../api';
import { SubscriptionType } from '../models/subscriptionType';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  extractLicenseTypes,
  normalizeSubscriptionPlanType,
} from 'utils/subscriptionPlanType';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchSubscriptionTypesSaga(
  action: FetchSubscriptionTypesRequestAction
) {
  try {
    let err: ApiError | null;
    //const { countryCode, taxNumber } = action.payload;

    const fetchSubscriptionTypesResponse: SubscriptionTypeResponse = yield call(
      fetchSubscriptionPlans
    );

    err = checkResponse(fetchSubscriptionTypesResponse?.responseMessage);
    if (err) throw err;

    const fromGtShape = Array.isArray(
      fetchSubscriptionTypesResponse?.data?.licenseTypes
    )
      ? fetchSubscriptionTypesResponse.data.licenseTypes
          .map(normalizeSubscriptionPlanType)
          .filter((plan): plan is SubscriptionType => Boolean(plan?.uuid))
      : [];
    const licenseTypes =
      fromGtShape.length > 0
        ? fromGtShape
        : extractLicenseTypes(fetchSubscriptionTypesResponse);

    yield put(fetchSubscriptionTypesSuccess(licenseTypes));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchSubscriptionTypesFailure());
  }
}
